import { Injectable } from '@angular/core';
import { LoggedInUser } from '../models/loggedinuser';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private http:HttpClient, private configService:ConfigurationService) { 
    this.authenticationSubject = new BehaviorSubject<string>('');
    this.authenticationSubscription = this.authenticationSubject.asObservable();
  }

  loggedInUser:LoggedInUser|null = null;
  localStorageUserKey = this.configService.environment + '.shottrak.loggedinuser';
  authenticationSubject:BehaviorSubject<string>;
  authenticationSubscription:Observable<string>;

  login(username:string, password:string):Promise<any> {
    let endpoint = this.configService.getApiEndpoint() + "/login";
    return firstValueFrom(this.http.post(endpoint, {"username": username, "password": password}));
  }

  publishLogin():void {
    this.authenticationSubject.next("LOGIN");
  }

  publishLogout():void {
    this.authenticationSubject.next("LOGOUT");
  }

  setIsAuthenticated(username:string) {
    this.loggedInUser = { username: username };
    localStorage.setItem(this.localStorageUserKey, username);
  }

  isAuthenticated():boolean {
    let username = this.getUserFromStorage();
    if(username != null)
      this.loggedInUser = { username: username};
    return this.loggedInUser != null && this.loggedInUser.username.length > 0;
  }

  getUserFromStorage() {
    let username = localStorage.getItem(this.localStorageUserKey);
    if(username && username.length > 0)
      return username
    else
      return null;
  }

  logout() {
    this.loggedInUser = null;
    localStorage.removeItem(this.localStorageUserKey);
  }

  userIsAdministrator():boolean {
    if(this.isAuthenticated() && this.loggedInUser?.username === "krummy") {
      return true;
    }
    else {
      return false;
    }
  }
}
